import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
  se: {
    // eslint-disable-next-line
    message: require('../wwwroot/languages/se.lang')
  },
  en: {
    // eslint-disable-next-line
    message: require('../wwwroot/languages/en.lang')
  // eslint-disable-next-line
  }
};

const i18n = new VueI18n({
  locale: 'se', // set locale
  fallbackLocale: 'en', // set fallback locale
  messages, // set locale messages
});

export default i18n;
